export const getBaseCode = (langObj) => {
  if (!langObj) return "";
  
  if (typeof langObj === "object" && langObj.locale) {
    return langObj.locale.split("-")[0];
  }
  
  if (typeof langObj === "object" && langObj.name) {
    return langObj.name.substring(0, 2).toLowerCase();
  }

  if (typeof langObj === "string") {
    return langObj.split("-")[0];
  }
  
  return "";
};